import React from 'react'

import { useObserver } from 'mobx-react';

import { CustomerAPI, IAssetPasswordReq } from '@api/index';
import { useStore } from '@store/index';
import { I18n } from '@utils/index';

import { MainProps } from '../SetPassword';

export const useUserStore = () => {
  const { userStore } = useStore();
  return useObserver(() => userStore)
}

interface UseCommonReq {
  dataRef: React.MutableRefObject<Partial<IAssetPasswordReq>>
}

// const InKyc2State = [IKycStatus.L1_SUCCESS, IKycStatus.L2_AUDIIING, IKycStatus.L2_REJECT, IKycStatus.L2_SUCCESS]

/** 发送空投和设置资金密码用到的公共逻辑 */
export const useCommon = (props: UseCommonReq) => {
  const { dataRef } = props;
  /** 验证资金密码是否正确 */
  const verifyAssetPwd: MainProps['onComplete'] = async (pwd) => {
    const res = await CustomerAPI.assetPwdVerify({ assetPwd: pwd });
    if (res.success) {
      dataRef.current.tokenId = res.obj
      return {
        status: 'DONE'
      }
    }
    if (res.msgKey === 'customer.asset.password.limit') {
      return {
        errorText: I18n.t('tsoVHfYj')
      };
    }
    return {
      errorText: I18n.t(res.msgKey)
    }
  }

  return {
    verifyAssetPwd
  }
}
